import { ChangeDetectorRef, Directive, ElementRef, HostBinding, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationInitiatorService } from '../notification/notification-initiator.service';
import { Status } from '@df/core/status';

@Directive()
export abstract class AbstractButtonComponent implements OnChanges, OnDestroy, OnInit {
    @Input()
    status?: Status;

    /**
     * We can also pass busy  directly (without status)
     */
    @Input()
    busy = false;

    @Input()
    icon?: string;

    @HostBinding('class._left-icon')
    @Input()
    leftIcon?: boolean = false;

    @Input()
    notification?: string;

    protected abstract variantInputName: string | undefined;

    private statusSubscription?: Subscription;
    private existingButtonClass = '';

    constructor(
        protected renderer2: Renderer2,
        protected elementRef: ElementRef,
        protected ref: ChangeDetectorRef,
        private notificationInitiatorService: NotificationInitiatorService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['status']) {
            this.statusSubscription?.unsubscribe();
            this.statusSubscription = this.status?.subject.subscribe(() => this.onStatusChange());
        }
        if (this.variantInputName && changes[this.variantInputName]) {
            this.applyVariantClass();
        }
        if (changes['status'] || changes['busy']) {
            this.updateStatusClasses();
        }
    }

    ngOnInit() {
        this.applyVariantClass();
    }

    private applyVariantClass() {
        if (this.variantInputName) {
            const newClass = `_${this[this.variantInputName] || 'default'}`;
            if (this.existingButtonClass && this.existingButtonClass !== newClass) {
                this.renderer2.removeClass(this.elementRef.nativeElement, this.existingButtonClass);
            }
            if (newClass) {
                this.existingButtonClass = newClass;
                this.renderer2.addClass(this.elementRef.nativeElement, newClass);
            }
        }
    }

    ngOnDestroy() {
        this.statusSubscription?.unsubscribe();
    }

    get isBusy() {
        return this.busy || this.status?.busy;
    }

    private onStatusChange() {
        this.updateStatusClasses();
        if (this.notification && this.status?.error) {
            this.notificationInitiatorService.push({
                title: this.notification,
                message: this.status.error
            });
        }
        this.ref.detectChanges();
    }

    private updateStatusClasses() {
        this.isBusy ?
            this.renderer2.addClass(this.elementRef.nativeElement, '_busy'):
            this.renderer2.removeClass(this.elementRef.nativeElement, '_busy');
    }
}
